<template>
  <div v-if="loading" class="loading-screen">
    <img style="width:20px; height:20px" src="@/assets/hamster.gif" alt="Loading..." />
    <p>Loading, please wait...</p>
  </div>
  <div v-else class="list row">
    <div class="col-md-8">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Search by name, email, ID, or group code"
          v-model="searchQuery"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="searchReservations">
            Search
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <h4>Reservation List</h4>
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Group Code</th>
            <th>Activity Date</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Balance Owing</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(reservation, index) in reservations" :key="reservation.reservationid">
            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td>{{ reservation.groupcode }}</td>
            <td>{{ reservation.activitydate }}</td>
            <td>{{ reservation.person.firstname }}</td>
            <td>{{ reservation.person.lastname }}</td>
            <td>{{ reservation.person.email }}</td>
            <td>{{ reservation.balanceowing }}</td>
            <td>
              <router-link :to="{ name: 'reservation', params: { id: reservation.reservationid }}">Edit</router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li v-if="totalPages > 1" class="page-item" :class="{ active: currentPage === 1 }">
            <button class="page-link" @click="changePage(1)">1</button>
          </li>
          <li v-if="currentPage > 4">
            <span class="page-link">...</span>
          </li>
          <li
            v-for="page in pagesToShow"
            :key="page"
            class="page-item"
            :class="{ active: currentPage === page }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li v-if="currentPage < totalPages - 3">
            <span class="page-link">...</span>
          </li>
          <li v-if="totalPages > 1" class="page-item" :class="{ active: currentPage === totalPages }">
            <button class="page-link" @click="changePage(totalPages)">{{ totalPages }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import ReservationDataService from "../../services/ReservationDataService.js";

export default {
  name: "reservation-list",
  data() {
    return {
      reservations: [],
      searchQuery: "",
      currentPage: 1,
      pageSize: 50,
      totalItems: 0,
      totalPages: 0,
      loading: true,
    };
  },
  computed: {
    pagesToShow() {
      const range = [];
      const start = Math.max(2, this.currentPage - 2);
      const end = Math.min(this.totalPages - 1, this.currentPage + 2);
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      return range;
    },
  },
  methods: {
    retrieveReservations(page = 1) {
      this.loading = true;
      ReservationDataService.getAllPaginated(page, this.pageSize)
        .then((response) => {
          this.reservations = response.data.reservations;
          this.totalItems = response.data.totalItems;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPage;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchReservations() {
      if (!this.searchQuery.trim()) {
        this.retrieveReservations(1);
      } else {
        ReservationDataService.search(this.searchQuery)
          .then((response) => {
            this.reservations = response.data;
            this.totalItems = response.data.length;
            this.totalPages = 1;
            this.currentPage = 1;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.retrieveReservations(page);
      }
    },
  },
  mounted() {
    this.retrieveReservations();
  },
};
</script>


<style>
.list {
  text-align: left;
  max-width: 950px;
  margin: auto;
}

.loading-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}

.loading-screen img {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}
</style>
  